import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider, createUnifiedTheme, palettes } from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';

const fieldTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    background: { default: '#121212', paper: '#1e1e1e' },
    primary: { main: '#90caf9' },
    navigation: {
      background: '#1e1e1e',
      indicator: '#90caf9',
      color: '#999',
      selectedColor: '#fff',
      navItem: { hoverBackground: '#2e2e2e' },
    },
  },
  defaultPageTheme: 'home',
});

const themeExtension = ThemeBlueprint.make({
  name: 'field-dark',
  params: {
    theme: {
      id: 'field-dark',
      title: 'Field Launchpad',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={fieldTheme} children={children} />
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [themeExtension],
});
